import Notifications from 'react-notification-system-redux';
import { adopted } from '../../../general/apiScenarios';
import { _select, ListenerApiLight, lm } from '../../listenerMiddleware';
import { logger } from '../../logger';
import * as sharedLinksActions from '../sharedLinks/actions';
import { getSelectedShareIds } from '../sharedLinks/selectors';
import * as sharedLinksRemoverActions from './actions';
import { Messages } from './model';
import { getBulkJobID } from './selectors';

export function sharedLinksRemoverListener() {
  lm.takeEvery(sharedLinksRemoverActions.deleteButtonClicked, async (_, lapi) => {
    const selected = _select(lapi, getSelectedShareIds);
    const bulkJobID = _select(lapi, getBulkJobID);
    const result = await deleteShares(lapi, selected, bulkJobID);
    lapi.signal.throwIfAborted();
    if (!result.success) lapi.dispatch(Notifications.error(Messages.removeError()));
    else lapi.dispatch(sharedLinksActions.loadSharesRequested());
    const bulkJobIDAfter = _select(lapi, getBulkJobID);
    if (bulkJobID === bulkJobIDAfter) {
      lapi.dispatch(sharedLinksRemoverActions.modalClosed());
    }
  });
  lm.takeEvery(sharedLinksRemoverActions.modalCloseUiEvent, function (_, lapi) {
    lapi.dispatch(sharedLinksRemoverActions.modalClosed());
  });
  lm.takeEvery(sharedLinksRemoverActions.modalOpenedUiEvent, function (_, lapi) {
    const shareIDs = _select(lapi, getSelectedShareIds);
    lapi.dispatch(sharedLinksRemoverActions.modalOpened({ shareIDs }));
  });
}

async function deleteShares(lapi: ListenerApiLight, shareIDs: string[], bulkJobID: string | null) {
  try {
    lapi.dispatch(sharedLinksRemoverActions.deleteStarted({ shareIDs, bulkJobID }));
    const result = await adopted.sharedLinksAPI.deleteSharedLinks(shareIDs);
    lapi.signal.throwIfAborted();
    for (const shareID of shareIDs) {
      logger.lapi(lapi, {
        action: 'Share',
        sub_action: 'Delete',
        extra: { text_2: shareID },
      });
    }
    lapi.dispatch(sharedLinksRemoverActions.deleteSuccess({ result, shareIDs, bulkJobID }));
    return { nodeIDs: shareIDs, success: true };
  } catch (error) {
    lapi.dispatch(sharedLinksRemoverActions.deleteError({ error, shareIDs, bulkJobID }));
    return { nodeIDs: shareIDs, success: false };
  }
}
